import { gql } from "@apollo/client";

export const ADD_DISPATCHER = gql`
  mutation AddDispatcher($data: DispatcherDataInput) {
    addDispatcher(data: $data) {
      id
    }
  }
`;

export const UPDATE_DISPATCHER = gql`
  mutation UpdateDispatcher(
    $where: DispatcherWhereInput
    $data: DispatcherDataInput
  ) {
    updateDispatcher(where: $where, data: $data) {
      id
      active
    }
  }
`;

export const DELETE_DISPATCHER = gql`
  mutation DeleteDispatcher($where: DispatcherWhereInput) {
    deleteDispatcher(where: $where) {
      id
    }
  }
`;

export const LINK_CHILD_ORGANIZATION = gql`
  mutation LinkChildOrganization($where: OrganizationWhereInput) {
    linkChildOrganization(where: $where) {
      id
      createdByOrganizationId
    }
  }
`;

const dispatchers = {
  ADD_DISPATCHER,
  UPDATE_DISPATCHER,
  DELETE_DISPATCHER,
  LINK_CHILD_ORGANIZATION,
};

export default dispatchers;
